import gql from "graphql-tag"

import wellnessLane from "./WellnessLane"

const fragment = gql`
  fragment wellnessHomepage on WellnessHomepage {
    hero {
      uuid
      title
      thumbnail
      description
      heroImage
    }
    lanes {
      ...wellnessLane
    }
  }
  ${wellnessLane}
`

export const toString = fragment.loc.source.body

export default fragment
